import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../../Context'
import { AuthContextApi } from '../../../Context/api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import './index.css'
import {
    PlusIcon,
    MagnifyingGlassIcon,
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    TruckIcon,
    UserIcon,
    PhoneIcon,
    EnvelopeIcon,
    IdentificationIcon,
    MapPinIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    PencilSquareIcon,
    ClockIcon,
    TrashIcon
} from '@heroicons/react/24/outline'
import { jsonConfig } from '../../../Config'
// Funções de formatação
const formatTelefone = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 11 dígitos (DDD + 9 dígitos)
    const limitedNumbers = numbers.slice(0, 11)

    // Aplica a máscara de telefone
    if (limitedNumbers.length <= 10) {
        return limitedNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
    } else {
        return limitedNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    }
}

const formatCPFCNPJ = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 14 dígitos (máximo para CNPJ)
    const limitedNumbers = numbers.slice(0, 14)

    // Aplica a máscara baseada no tamanho
    if (limitedNumbers?.length <= 11) {
        // CPF
        return limitedNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else {
        // CNPJ
        return limitedNumbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }
}

const formatCEP = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 8 dígitos
    const limitedNumbers = numbers.slice(0, 8)

    // Aplica a máscara de CEP
    return limitedNumbers.replace(/(\d{5})(\d{3})/, '$1-$2')
}

const Clientes = () => {
    const { states, setters } = useContext(AuthContext)
    const { getEntidades, postEntidades, putEntidades, getEstatisticasEntidades, deleteEntidades } = useContext(AuthContextApi)
    const navigate = useNavigate()

    // Função para retornar ao painel de entidades
    const navigateToEntidades = () => {
        navigate(-1)
    }

    // Função para navegar para a página unitária do cliente
    const navigateToCliente = (cliente) => {
        navigate(`/cadastros/clientes/cliente/${cliente.id}`)
    }

    // Função para navegar para o histórico do cliente
    const navigateToHistorico = (cliente) => {
        navigate(`/cadastros/clientes/${cliente.id}`)
    }

    // Estados locais
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('nome')
    const [selectedSortField, setSelectedSortField] = useState('nome')
    const [sortDirection, setSortDirection] = useState('asc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [selectedEntidade, setSelectedEntidade] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [entidadeToDelete, setEntidadeToDelete] = useState(null)

    // Estados do formulário
    const [entidadeNome, setEntidadeNome] = useState('')
    const [entidadeNumero, setEntidadeNumero] = useState('')
    const [entidadeEmail, setEntidadeEmail] = useState('')
    const [entidadeTelefone, setEntidadeTelefone] = useState('')
    const [entidadeCpfCnpj, setEntidadeCpfCnpj] = useState('')
    const [entidadeCep, setEntidadeCep] = useState('')
    const [entidadeNomeLocalizacao, setEntidadeNomeLocalizacao] = useState('')

    // Função para carregar clientes (apenas tipo 1)
    const loadClientes = async () => {
        console.log('loadClientes')
        const query = new URLSearchParams({
            page: states.page,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: searchTerm,
            tipo: '1' // Filtra apenas clientes
        }).toString()

        await getEntidades(query)
    }


    // Função para buscar
    const handleSearch = () => {
        setters.setPage(0)
        loadClientes()
    }

    // Função para limpar busca
    const handleClear = () => {
        setSearchTerm('')
        setSelectedFilterField('nome')
        setSelectedSortField('nome')
        setSortDirection('asc')
        setters.setPage(0)
        loadClientes()
    }

    // Função para próxima página
    const handleNext = () => {
        setters.setPage(states.page + 1)
    }

    // Função para página anterior
    const handlePrevious = () => {
        if (states.page >= 0) {
            states.page > 0 && setters.setPage(states.page - 1)
        }
    }

    // Função para abrir modal
    const openModal = (entidade = null) => {
        if (entidade) {
            setIsEditMode(true)
            setSelectedEntidade(entidade)
            setEntidadeNome(entidade.nome || '')
            setEntidadeNumero(entidade.numero || '')
            setEntidadeEmail(entidade.email || '')
            setEntidadeTelefone(entidade.telefone || '')
            setEntidadeCpfCnpj(entidade.cpf_cnpj || '')
            setEntidadeCep(entidade.cep || '')
            setEntidadeNomeLocalizacao(entidade.nomeLocalizacao || '')
        } else {
            setIsEditMode(false)
            setSelectedEntidade({})
            setEntidadeNome('')
            setEntidadeNumero('')
            setEntidadeEmail('')
            setEntidadeTelefone('')
            setEntidadeCpfCnpj('')
            setEntidadeCep('')
            setEntidadeNomeLocalizacao('')
        }
        setIsModalOpen(true)
    }

    // Função para fechar modal
    const closeModal = () => {
        setIsModalOpen(false)
        setIsEditMode(false)
        setSelectedEntidade({})
        setEntidadeNome('')
        setEntidadeNumero('')
        setEntidadeEmail('')
        setEntidadeTelefone('')
        setEntidadeCpfCnpj('')
        setEntidadeCep('')
        setEntidadeNomeLocalizacao('')
        setIsSubmitting(false)
    }

    // Função para salvar cliente
    const handleSaveCliente = async () => {
        if (!entidadeNome.trim()) {
            toast.error('Nome é obrigatório')
            return
        }

        if (!entidadeEmail.trim()) {
            toast.error('Email é obrigatório')
            return
        }

        if (!entidadeTelefone.trim()) {
            toast.error('Telefone é obrigatório')
            return
        }

        if (!entidadeCpfCnpj.trim()) {
            toast.error('CPF/CNPJ é obrigatório')
            return
        }

        if (!entidadeNomeLocalizacao.trim() && !isEditMode) {
            toast.error('Nome da Localização é obrigatório')
            return
        }

        setIsSubmitting(true)

        const clienteData = {
            nome: entidadeNome.trim(),
            tipo: 1, // Sempre cliente
            numero: entidadeNumero.trim(),
            email: entidadeEmail.trim(),
            telefone: entidadeTelefone.trim(),
            cpf_cnpj: entidadeCpfCnpj.trim(),
            cep: entidadeCep.trim(),
            nomeLocalizacao: entidadeNomeLocalizacao.trim()
        }

        if (isEditMode) {
            clienteData.id = selectedEntidade.id
            delete clienteData.tipo
            delete clienteData.nomeLocalizacao
            delete clienteData.cep
            const success = await putEntidades(clienteData)
            if (success) {
                closeModal()
                setTimeout(() => {
                    loadClientes()
                }, 500)
            }
        } else {
            const success = await postEntidades(clienteData)
            if (success) {
                closeModal()
                setTimeout(() => {
                    loadClientes()
                }, 500)
            }
        }

        setIsSubmitting(false)
    }

    // Função para abrir modal de confirmação de exclusão
    const openDeleteModal = (entidade) => {
        setEntidadeToDelete(entidade)
        setIsDeleteModalOpen(true)
    }

    // Função para fechar modal de confirmação de exclusão
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false)
        setEntidadeToDelete(null)
    }

    // Função para confirmar exclusão
    const handleConfirmDelete = async () => {
        if (!entidadeToDelete) return

        setIsSubmitting(true)
        const success = await deleteEntidades(entidadeToDelete.id)

        if (success) {
            closeDeleteModal()
            // Recarrega as entidades imediatamente após exclusão
            await loadClientes()
        }

        setIsSubmitting(false)
    }

    // Função para verificar se pode deletar
    const canDeleteEntidade = (entidade) => {
        const userEmail = localStorage.getItem('usuario')
        return entidade.canDelete === true && userEmail === jsonConfig.userMaster
    }

    // useEffect para monitorar mudanças nas variáveis de query
    useEffect(() => {
        if (states.page >= 0 && states.dataEntidades.length > 0) {
            loadClientes()
        }
    }, [states.page, recordsPerPage, selectedSortField, sortDirection])


    // useEffect para limpeza ao desmontar
    useEffect(() => {
        getEstatisticasEntidades()
        loadClientes()
        return () => {
            setters.setDataEntidades([])
            setters.setPage(0)
            setters.setIsLoading(false)
            setters.setDataEstatisticaEntidades([])
        }
    }, [])




    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30">
            {/* Header Artístico */}
            <div className="relative bg-gradient-to-br from-blue-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm border-b border-gradient-to-r from-blue-200/50 to-blue-200/50 sticky top-0 z-10">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-blue-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex items-center">
                            <button
                                onClick={navigateToEntidades}
                                className="group mr-6 p-3 rounded-2xl bg-white/20 backdrop-blur-sm border border-blue-200/50 hover:bg-blue-100/50 transition-all duration-300 transform hover:scale-105"
                            >
                                <ArrowLeftIcon className="w-6 h-6 text-blue-700 group-hover:text-blue-800 transition-colors duration-200" />
                            </button>
                            <div>
                                <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-800 bg-clip-text text-transparent">
                                    Clientes
                                </h1>
                                <p className="mt-3 text-lg text-gray-600 font-medium">
                                    Gerencie os clientes do sistema
                                </p>
                            </div>
                        </div>
                        <div className="mt-6 sm:mt-0">
                            <button
                                onClick={() => openModal()}
                                className="group relative inline-flex items-center px-8 py-4 border border-transparent rounded-2xl shadow-xl text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <PlusIcon className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform duration-200" />
                                    <span className="text-base font-bold">Novo Cliente</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conteúdo Principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Cards de Estatísticas - Design Artístico */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 mb-8">
                    {states.dataEstatisticaEntidades && states.dataEstatisticaEntidades?.length > 0 && states.dataEstatisticaEntidades?.map((card, index) => {
                        // Filtra apenas estatísticas de clientes
                        if (!card.title.includes('Cliente')) return null

                        return (
                            <div key={card.title} className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50/30 backdrop-blur-sm rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>
                                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/10 to-blue-400/10 rounded-full -translate-y-12 translate-x-12"></div>
                                <div className="relative p-6">
                                    <div className="flex items-center justify-between mb-4">
                                        <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 shadow-lg">
                                            <UserIcon className="w-6 h-6 text-white" />
                                        </div>
                                        <div className="text-right">
                                            <div className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-800 bg-clip-text text-transparent">
                                                {card.value}
                                            </div>
                                        </div>
                                    </div>
                                    <h3 className="text-lg font-semibold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-700 bg-clip-text text-transparent">
                                        {card.title}
                                    </h3>
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* Formulário de Busca - Design Artístico */}
                <div className="relative bg-gradient-to-br from-blue-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-3xl shadow-lg border border-blue-100/50 mb-8 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-blue-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                    <div className="relative p-6">
                        <div className="flex items-center mb-4">
                            <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-600 shadow-lg mr-4">
                                <MagnifyingGlassIcon className="w-6 h-6 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-800 bg-clip-text text-transparent">
                                Pesquisa Avançada
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Termo de Busca</label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch()
                                        }
                                    }}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Digite para buscar..."
                                    className="w-full px-4 py-3 border border-blue-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Filtro</label>
                                <select
                                    value={selectedFilterField}
                                    onChange={(e) => setSelectedFilterField(e.target.value)}
                                    className="w-full px-4 py-3 border border-blue-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value="cpf_cnpj">CPF/CNPJ</option>
                                    <option value="data_atualizacao">Data de Atualização</option>
                                    <option value="data_criacao">Data de Criação</option>
                                    <option value="email">Email</option>
                                    <option value="nome">Nome</option>
                                    <option value="telefone">Telefone</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Ordenação</label>
                                <select
                                    value={selectedSortField}
                                    onChange={(e) => setSelectedSortField(e.target.value)}
                                    className="w-full px-4 py-3 border border-blue-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value="cpf_cnpj">CPF/CNPJ</option>
                                    <option value="data_atualizacao">Data de Atualização</option>
                                    <option value="data_criacao">Data de Criação</option>
                                    <option value="email">Email</option>
                                    <option value="nome">Nome</option>
                                    <option value="telefone">Telefone</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Direção da Ordenação</label>
                                <select
                                    value={sortDirection}
                                    onChange={(e) => setSortDirection(e.target.value)}
                                    className="w-full px-4 py-3 border border-blue-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value="asc">Crescente (A-Z)</option>
                                    <option value="desc">Decrescente (Z-A)</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Registros por Página</label>
                                <select
                                    value={recordsPerPage}
                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                    className="w-full px-4 py-3 border border-blue-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value={5}>5 registros</option>
                                    <option value={10}>10 registros</option>
                                    <option value={20}>20 registros</option>
                                    <option value={50}>50 registros</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={handleSearch}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <MagnifyingGlassIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Buscar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>

                            <button
                                onClick={handleClear}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-blue-300 rounded-2xl shadow-lg text-sm font-semibold text-blue-700 bg-gradient-to-r from-blue-50 to-blue-50 hover:from-blue-100 hover:to-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <XMarkIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Limpar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Lista de Clientes - Design Artístico */}
                <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-sm border border-white/50 overflow-hidden">
                    {/* Cabeçalho da Tabela */}
                    <div className="bg-gradient-to-r from-blue-50 to-blue-100/50 px-6 py-4 border-b border-blue-200/50">
                        <div className="grid grid-cols-7 gap-4 text-sm font-semibold text-gray-700">
                            <div className="text-center">Ações</div>
                            <div className="text-center">Nome</div>
                            <div className="text-center">Email</div>
                            <div className="text-center">Telefone</div>
                            <div className="text-center">CPF/CNPJ</div>
                            <div className="text-center">Criado em</div>
                            <div className="text-center">Status</div>
                        </div>
                    </div>

                    {/* Lista de Clientes */}
                    <div className="divide-y divide-gray-200/50">
                        {states.dataEntidades && states.dataEntidades?.length > 0 && states.dataEntidades?.map((entidade) => (
                            <div
                                key={entidade.id}
                                className="px-6 py-4 hover:bg-blue-50/30 transition-colors duration-200 cursor-pointer group"
                                onClick={() => navigateToCliente(entidade)}
                            >
                                <div className="grid grid-cols-7 gap-4 items-center">
                                    {/* Ações */}
                                    <div className="flex items-center justify-center space-x-2">
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                openModal(entidade)
                                            }}
                                            className="p-2 rounded-lg hover:bg-blue-100 transition-colors duration-200 group-hover:scale-110"
                                            title="Editar Cliente"
                                        >
                                            <PencilSquareIcon className="w-4 h-4 text-blue-600" />
                                        </button>
                                        {canDeleteEntidade(entidade) && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    openDeleteModal(entidade)
                                                }}
                                                className="p-2 rounded-lg hover:bg-red-100 transition-colors duration-200 group-hover:scale-110"
                                                title="Excluir Cliente"
                                            >
                                                <TrashIcon className="w-4 h-4 text-red-600" />
                                            </button>
                                        )}
                                    </div>

                                    {/* Nome do cliente */}
                                    <div className="text-center">
                                        <span className="text-sm font-medium text-gray-900 text-center">
                                            {entidade.nome}
                                        </span>
                                    </div>

                                    {/* Email */}
                                    <div className="text-center">
                                        <span className="text-sm text-gray-700">
                                            {entidade.email || '-'}
                                        </span>
                                    </div>

                                    {/* Telefone */}
                                    <div className="text-center">
                                        <span className="text-sm text-gray-700">
                                            {entidade.telefone ? formatTelefone(entidade.telefone) : '-'}
                                        </span>
                                    </div>

                                    {/* CPF/CNPJ */}
                                    <div className="text-center">
                                        <span className="text-sm text-gray-700">
                                            {entidade.cpf_cnpj ? formatCPFCNPJ(entidade.cpf_cnpj) : '-'}
                                        </span>
                                    </div>

                                    {/* Data de criação */}
                                    <div className="text-center">
                                        <span className="text-sm text-gray-700">
                                            {new Date(entidade.data_criacao).toLocaleDateString('pt-BR')}
                                        </span>
                                    </div>

                                    {/* Status */}
                                    <div className="text-center">
                                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200">
                                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></div>
                                            Cliente
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Mensagem quando não há clientes */}
                    {(!states.dataEntidades || states.dataEntidades?.length === 0) && (
                        <div className="text-center py-12">
                            <UserIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum cliente encontrado</h3>
                            <p className="text-gray-500">Clique em "Novo Cliente" para criar o primeiro cliente.</p>
                        </div>
                    )}
                </div>

                {/* Paginação */}
                {states.dataEntidades && states.dataEntidades?.length > 0 && (
                    <div className="flex items-center justify-between bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
                        <div className="text-sm text-gray-700">
                            Mostrando {(states.page * recordsPerPage) + 1} a {Math.min((states.page + 1) * recordsPerPage, states.dataEntidades?.length || 0)} de {states.dataEntidades?.length || 0} clientes
                        </div>
                        <div className="flex space-x-2">
                            <button
                                onClick={handlePrevious}
                                disabled={states.page === 0}
                                className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                            >
                                <ChevronLeftIcon className="w-4 h-4" />
                            </button>
                            <span className="px-3 py-2 text-sm font-medium text-gray-700">
                                Página {states.page + 1}
                            </span>
                            <button
                                onClick={handleNext}
                                disabled={(states.dataEntidades?.length || 0) < recordsPerPage}
                                className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                            >
                                <ChevronRightIcon className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                )}

                {/* Mensagem quando não há dados */}
                {(!states.dataEntidades || states.dataEntidades?.length === 0) && (
                    <div className="text-center py-12">
                        <UserIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum cliente encontrado</h3>
                        <p className="text-gray-500 mb-6">Comece criando seu primeiro cliente para ver os dados aqui.</p>
                        <button
                            onClick={() => openModal()}
                            className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <PlusIcon className="w-4 h-4 mr-2" />
                            Criar Cliente
                        </button>
                    </div>
                )}
            </div>

            {/* Modal de Adicionar/Editar Cliente */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="relative shrink-0 bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <UserIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            {isEditMode ? 'Editar Cliente' : 'Novo Cliente'}
                                        </h2>
                                        <p className="text-blue-100 mt-1">
                                            {isEditMode ? 'Atualize os dados do cliente' : 'Preencha os dados para criar um novo cliente'}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 space-y-6 overflow-y-auto p-6">
                            {/* Nome */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Nome do Cliente *
                                </label>
                                <input
                                    type="text"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveCliente()
                                        }
                                    }}
                                    value={entidadeNome}
                                    onChange={(e) => setEntidadeNome(e.target.value)}
                                    placeholder="Digite o nome do cliente"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Email *
                                </label>
                                <input
                                    type="email"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveCliente()
                                        }
                                    }}
                                    value={entidadeEmail}
                                    onChange={(e) => setEntidadeEmail(e.target.value)}
                                    placeholder="Digite o email"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                />
                            </div>

                            {/* Telefone */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Telefone *
                                </label>
                                <input
                                    type="tel"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveCliente()
                                        }
                                    }}
                                    value={entidadeTelefone}
                                    onChange={(e) => setEntidadeTelefone(formatTelefone(e.target.value))}
                                    placeholder="(11) 99999-9999"
                                    maxLength={15}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                />
                            </div>

                            {/* CPF/CNPJ */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    CPF/CNPJ *
                                </label>
                                <input
                                    type="text"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveCliente()
                                        }
                                    }}
                                    value={entidadeCpfCnpj}
                                    onChange={(e) => setEntidadeCpfCnpj(formatCPFCNPJ(e.target.value))}
                                    placeholder="000.000.000-00 ou 00.000.000/0000-00"
                                    maxLength={18}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                />
                            </div>

                            {
                                !isEditMode && (
                                    <>
                                        {/* Número */}
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                Número
                                            </label>
                                            <input
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSaveCliente()
                                                    }
                                                }}
                                                value={entidadeNumero}
                                                onChange={(e) => setEntidadeNumero(e.target.value)}
                                                placeholder="Digite o número"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            />
                                        </div>

                                        {/* CEP */}
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                CEP
                                            </label>
                                            <input
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSaveCliente()
                                                    }
                                                }}
                                                value={entidadeCep}
                                                onChange={(e) => setEntidadeCep(formatCEP(e.target.value))}
                                                placeholder="00000-000"
                                                maxLength={9}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            />
                                        </div>

                                        {/* Nome da Localização */}
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                Nome da Localização *
                                            </label>
                                            <input
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSaveCliente()
                                                    }
                                                }}
                                                value={entidadeNomeLocalizacao}
                                                onChange={(e) => setEntidadeNomeLocalizacao(e.target.value)}
                                                placeholder="Digite o nome da localização"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">
                                                Nome da localização do cliente
                                            </p>
                                        </div>
                                    </>
                                )
                            }

                        </div>

                        {/* Footer do Modal */}
                        <div className="flex shrink-0 items-center justify-end space-x-4 border-t border-gray-200 p-6">
                            <button
                                onClick={closeModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSaveCliente}
                                disabled={isSubmitting}
                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="relative z-10 flex items-center">
                                    {isSubmitting ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                    ) : (
                                        <PlusIcon className="w-4 h-4 mr-2" />
                                    )}
                                    <span>{isSubmitting ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Criar')}</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmação de Exclusão */}
            {isDeleteModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full">
                        {/* Header do Modal */}
                        <div className="relative bg-gradient-to-r from-red-600 via-red-700 to-red-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <TrashIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Confirmar Exclusão
                                        </h2>
                                        <p className="text-red-100 mt-1">
                                            Esta ação não pode ser desfeita
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeDeleteModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="p-6">
                            <div className="text-center">
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                                    <TrashIcon className="h-6 w-6 text-red-600" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">
                                    Tem certeza que deseja excluir este cliente?
                                </h3>
                                <p className="text-sm text-gray-500 mb-4">
                                    O cliente <strong>{entidadeToDelete?.nome}</strong> será permanentemente removido do sistema.
                                </p>
                                <p className="text-xs text-red-600 font-medium">
                                    Esta ação não pode ser desfeita.
                                </p>
                            </div>
                        </div>

                        {/* Footer do Modal */}
                        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200">
                            <button
                                onClick={closeDeleteModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleConfirmDelete}
                                disabled={isSubmitting}
                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-red-600 via-red-700 to-red-700 hover:from-red-700 hover:via-red-800 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="relative z-10 flex items-center">
                                    {isSubmitting ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                    ) : (
                                        <TrashIcon className="w-4 h-4 mr-2" />
                                    )}
                                    <span>{isSubmitting ? 'Excluindo...' : 'Excluir'}</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Clientes